import type { GroupKey, TodoId } from "@common/types/todo";
import type { Flavor } from "@common/utils/type-utils";

export type SelectableId = Flavor<string, "SELECTABLE_ID">;
export function selectableIdToTodoId(selectableId: SelectableId): TodoId {
  const [todoId, groupKey] = selectableId.split(":");
  if (!todoId) throw new Error(`Malformed selectable id ${selectableId}`);
  return todoId;
}

export function todoIdToSelectableId(todoId: TodoId, groupKey: GroupKey): SelectableId {
  return `${todoId}:${groupKey}`;
}

export type DraggableId = Flavor<string, "DRAGGABLE_ID">;
export type DroppableId = Flavor<string, "DROPPABLE_ID">;
export type DroppableGroupId = Flavor<string, "DROPPABLE_GROUP_ID">;

export function todoIdToDraggableId(todoId: TodoId, groupKey: GroupKey): DraggableId {
  return `${todoId}:${groupKey}`;
}

export function todoIdToDroppableId(todoId: TodoId, groupKey: GroupKey): DroppableId {
  return `${todoId}:${groupKey}`;
}
